// Module 6: Overheard at Dinner (Verbal Reasoning) - All 10 Difficulty Levels
// Fill-in-the-blank dialogue completion instances

export const MODULE_6_INSTANCES = {
  1: {
    levelId: 1,
    difficulty: 1,
    dialogueTitle: "Hawaii Trip",
    blanks: [
      {
        blankIndex: 1,
        speaker: "Samantha",
        sentenceWithBlank: "I finally booked that [BLANK 1] to Hawaii next month. Took me forever to find decent flight prices.",
        correctAnswer: "trip",
        wordOptions: ["trip", "journey", "flight", "excited", "surf", "sunscreen", "but", "nervous", "drive", "because", "lotion", "ready", "since", "fly", "spray"],
        partOfSpeech: "noun"
      },
      {
        blankIndex: 2,
        speaker: "Roy",
        sentenceWithBlank: "Nice. I've heard the beaches there are incredible. What are you most [BLANK 2] about seeing?",
        correctAnswer: "excited",
        wordOptions: ["trip", "journey", "flight", "excited", "surf", "sunscreen", "but", "nervous", "drive", "because", "lotion", "ready", "since", "fly", "spray"],
        partOfSpeech: "adjective"
      },
      {
        blankIndex: 3,
        speaker: "Samantha",
        sentenceWithBlank: "Probably the ocean stuff. I signed up for lessons to learn how to [BLANK 3] while I'm there. Never tried it before.",
        correctAnswer: "surf",
        wordOptions: ["trip", "journey", "flight", "excited", "surf", "sunscreen", "but", "nervous", "drive", "because", "lotion", "ready", "since", "fly", "spray"],
        partOfSpeech: "verb"
      },
      {
        blankIndex: 4,
        speaker: "Roy",
        sentenceWithBlank: "Just don't forget to bring [BLANK 4] with you. I went to Miami last year and got completely fried on day one.",
        correctAnswer: "sunscreen",
        wordOptions: ["trip", "journey", "flight", "excited", "surf", "sunscreen", "but", "nervous", "drive", "because", "lotion", "ready", "since", "fly", "spray"],
        partOfSpeech: "noun"
      },
      {
        blankIndex: 5,
        speaker: "Samantha",
        sentenceWithBlank: "Yeah, I burn really easily too. I like the beach, [BLANK 5] I always end up looking like a lobster if I'm not careful.",
        correctAnswer: "but",
        wordOptions: ["trip", "journey", "flight", "excited", "surf", "sunscreen", "but", "nervous", "drive", "because", "lotion", "ready", "since", "fly", "spray"],
        partOfSpeech: "transition"
      }
    ]
  },
  2: {
    levelId: 2,
    difficulty: 2,
    dialogueTitle: "Future Plans",
    blanks: [
      {
        blankIndex: 1,
        speaker: "Manuel",
        sentenceWithBlank: "My parents won't stop bugging me about my future plans, but I'm just not ready to [BLANK 1] their expectations yet.",
        correctAnswer: "meet",
        wordOptions: ["meet", "although", "meaningful", "courage", "than", "enjoy", "because", "expensive", "money", "change", "until", "interesting", "height", "happiness", "if"],
        partOfSpeech: "verb"
      },
      {
        blankIndex: 2,
        speaker: "Joey",
        sentenceWithBlank: "Ugh, tell me about it! Parents can be super pushy, [BLANK 2] they're usually just worried about us in their own weird way.",
        correctAnswer: "although",
        wordOptions: ["meet", "although", "meaningful", "courage", "than", "enjoy", "because", "expensive", "money", "change", "until", "interesting", "height", "happiness", "if"],
        partOfSpeech: "transition"
      },
      {
        blankIndex: 3,
        speaker: "Manuel",
        sentenceWithBlank: "Yeah, exactly. I just want to make [BLANK 3] choices that actually matter to me, not just do what everyone thinks I should.",
        correctAnswer: "meaningful",
        wordOptions: ["meet", "although", "meaningful", "courage", "than", "enjoy", "because", "expensive", "money", "change", "until", "interesting", "height", "happiness", "if"],
        partOfSpeech: "adjective"
      },
      {
        blankIndex: 4,
        speaker: "Joey",
        sentenceWithBlank: "That takes serious [BLANK 4]. Most people cave because they're too scared to go against what everyone expects, you know?",
        correctAnswer: "courage",
        wordOptions: ["meet", "although", "meaningful", "courage", "than", "enjoy", "because", "expensive", "money", "change", "until", "interesting", "height", "happiness", "if"],
        partOfSpeech: "noun"
      },
      {
        blankIndex: 5,
        speaker: "Manuel",
        sentenceWithBlank: "It's not easy, but I'd rather take my time [BLANK 5] jump into something I'll hate just to make them happy.",
        correctAnswer: "than",
        wordOptions: ["meet", "although", "meaningful", "courage", "than", "enjoy", "because", "expensive", "money", "change", "until", "interesting", "height", "happiness", "if"],
        partOfSpeech: "transition"
      }
    ]
  },
  3: {
    levelId: 3,
    difficulty: 3,
    dialogueTitle: "Development Report",
    blanks: [
      {
        blankIndex: 1,
        speaker: "Peter",
        sentenceWithBlank: "Did any of you catch that [BLANK 1] on Channel 5 last night about the new development downtown?",
        correctAnswer: "report",
        wordOptions: ["report", "ignored", "opportunity", "supportive", "so", "series", "created", "problem", "or", "broadcast", "damaged", "disaster", "about", "angry", "then"],
        partOfSpeech: "noun"
      },
      {
        blankIndex: 2,
        speaker: "Pamela",
        sentenceWithBlank: "I did! They completely [BLANK 2] the potential impact on the local businesses. I actually wrote an angry email to the station afterward.",
        correctAnswer: "ignored",
        wordOptions: ["report", "ignored", "opportunity", "supportive", "so", "series", "created", "problem", "or", "broadcast", "damaged", "disaster", "about", "angry", "then"],
        partOfSpeech: "verb"
      },
      {
        blankIndex: 3,
        speaker: "Pamela",
        sentenceWithBlank: "Basically, they portrayed the new mall as this amazing [BLANK 3] for the community without mentioning how it's going to increase traffic by about 40% in an already congested area.",
        correctAnswer: "opportunity",
        wordOptions: ["report", "ignored", "opportunity", "supportive", "so", "series", "created", "problem", "or", "broadcast", "damaged", "disaster", "about", "angry", "then"],
        partOfSpeech: "noun"
      },
      {
        blankIndex: 4,
        speaker: "Peter",
        sentenceWithBlank: "Plus, they only interviewed people who were [BLANK 4] of the project. Not a single critical voice was included.",
        correctAnswer: "supportive",
        wordOptions: ["report", "ignored", "opportunity", "supportive", "so", "series", "created", "problem", "or", "broadcast", "damaged", "disaster", "about", "angry", "then"],
        partOfSpeech: "adjective"
      },
      {
        blankIndex: 5,
        speaker: "Peter",
        sentenceWithBlank: "Not a single critical voice was included, [BLANK 5] it was clearly just a puff piece for the developers.",
        correctAnswer: "so",
        wordOptions: ["report", "ignored", "opportunity", "supportive", "so", "series", "created", "problem", "or", "broadcast", "damaged", "disaster", "about", "angry", "then"],
        partOfSpeech: "transition"
      }
    ]
  },
  4: {
    levelId: 4,
    difficulty: 4,
    dialogueTitle: "Band Recording",
    blanks: [
      {
        blankIndex: 1,
        speaker: "Joey",
        sentenceWithBlank: "My band finally finished recording our new EP last weekend. It was such an [BLANK 1] process trying to get everyone's schedules to align.",
        correctAnswer: "exhausting",
        wordOptions: ["exhausting", "talking", "and", "manage", "supporters", "delicious", "walking", "while", "begin", "wonderful", "sleeping", "if", "invite", "enemies", "children"],
        partOfSpeech: "adjective"
      },
      {
        blankIndex: 2,
        speaker: "Peter",
        sentenceWithBlank: "That's awesome! Is this the project you've been [BLANK 2] about since last summer?",
        correctAnswer: "talking",
        wordOptions: ["exhausting", "talking", "and", "manage", "supporters", "delicious", "walking", "while", "begin", "wonderful", "sleeping", "if", "invite", "enemies", "children"],
        partOfSpeech: "verb"
      },
      {
        blankIndex: 3,
        speaker: "Joey",
        sentenceWithBlank: "Yeah, exactly. We ended up with five tracks that I'm really proud of, [BLANK 3] the sound quality is so much better than our last release.",
        correctAnswer: "and",
        wordOptions: ["exhausting", "talking", "and", "manage", "supporters", "delicious", "walking", "while", "begin", "wonderful", "sleeping", "if", "invite", "enemies", "children"],
        partOfSpeech: "transition"
      },
      {
        blankIndex: 4,
        speaker: "Roy",
        sentenceWithBlank: "How did you guys [BLANK 4] the recording costs? I remember you mentioned studios being really expensive.",
        correctAnswer: "manage",
        wordOptions: ["exhausting", "talking", "and", "manage", "supporters", "delicious", "walking", "while", "begin", "wonderful", "sleeping", "if", "invite", "enemies", "children"],
        partOfSpeech: "verb"
      },
      {
        blankIndex: 5,
        speaker: "Joey",
        sentenceWithBlank: "We actually ran a crowdfunding campaign that was surprisingly successful. Our [BLANK 5] were incredibly generous, which gave us enough studio time to really perfect each track.",
        correctAnswer: "supporters",
        wordOptions: ["exhausting", "talking", "and", "manage", "supporters", "delicious", "walking", "while", "begin", "wonderful", "sleeping", "if", "invite", "enemies", "children"],
        partOfSpeech: "noun"
      }
    ]
  },
  5: {
    levelId: 5,
    difficulty: 5,
    dialogueTitle: "Bike Lane Proposal",
    blanks: [
      {
        blankIndex: 1,
        speaker: "Pamela",
        sentenceWithBlank: "The city council finally approved the new bike lane [BLANK 1] for downtown. Now we just need to secure the final funding.",
        correctAnswer: "proposal",
        wordOptions: ["proposal", "benefit", "resistant", "however", "assuming", "project", "destroy", "allergic", "afterward", "funding", "damage", "vertical", "similarly", "whenever", "why"],
        partOfSpeech: "noun"
      },
      {
        blankIndex: 2,
        speaker: "Manuel",
        sentenceWithBlank: "That's great news! I've been reading about how bike lanes can actually [BLANK 2] local businesses because they make the area more accessible.",
        correctAnswer: "benefit",
        wordOptions: ["proposal", "benefit", "resistant", "however", "assuming", "project", "destroy", "allergic", "afterward", "funding", "damage", "vertical", "similarly", "whenever", "why"],
        partOfSpeech: "verb"
      },
      {
        blankIndex: 3,
        speaker: "Pamela",
        sentenceWithBlank: "Exactly! Some shop owners were initially [BLANK 3] to the idea, worried about losing parking spaces, but the data from other cities is really convincing.",
        correctAnswer: "resistant",
        wordOptions: ["proposal", "benefit", "resistant", "however", "assuming", "project", "destroy", "allergic", "afterward", "funding", "damage", "vertical", "similarly", "whenever", "why"],
        partOfSpeech: "adjective"
      },
      {
        blankIndex: 4,
        speaker: "Manuel",
        sentenceWithBlank: "I can see why they'd be concerned, [BLANK 4], sometimes you have to look at the bigger picture.",
        correctAnswer: "however",
        wordOptions: ["proposal", "benefit", "resistant", "however", "assuming", "project", "destroy", "allergic", "afterward", "funding", "damage", "vertical", "similarly", "whenever", "why"],
        partOfSpeech: "transition"
      },
      {
        blankIndex: 5,
        speaker: "Pamela",
        sentenceWithBlank: "The project should be completed by next spring, [BLANK 5] we don't run into any major delays with permits or construction issues.",
        correctAnswer: "assuming",
        wordOptions: ["proposal", "benefit", "resistant", "however", "assuming", "project", "destroy", "allergic", "afterward", "funding", "damage", "vertical", "similarly", "whenever", "why"],
        partOfSpeech: "transition"
      }
    ],
    contextLines: [
      {
        speaker: "Peter",
        text: "I'd love to do a story on this once it's further along. Might help build more community support.",
        position: "end"
      }
    ]
  },
  6: {
    levelId: 6,
    difficulty: 6,
    dialogueTitle: "Interactive History Project",
    blanks: [
      {
        blankIndex: 1,
        speaker: "Roy",
        sentenceWithBlank: "My students have been absolutely [BLANK 1] by this new interactive history project. I've never seen them so engaged before.",
        correctAnswer: "captivated",
        wordOptions: ["captivated", "premise", "simulate", "connect", "perspectives", "challenged", "idea", "understand", "escape", "surprised", "reasoning", "elucidate", "replace", "experiences", "facts"],
        partOfSpeech: "adjective"
      },
      {
        blankIndex: 2,
        speaker: "Samantha",
        sentenceWithBlank: "That's fantastic! What's the [BLANK 2] behind it? I'm always looking for ways to make scientific concepts more accessible too.",
        correctAnswer: "premise",
        wordOptions: ["captivated", "premise", "simulate", "connect", "perspectives", "challenged", "idea", "understand", "escape", "surprised", "reasoning", "elucidate", "replace", "experiences", "facts"],
        partOfSpeech: "noun"
      },
      {
        blankIndex: 3,
        speaker: "Roy",
        sentenceWithBlank: "Instead of just reading about historical events, they have to [BLANK 3] the decision-making processes of key historical figures and defend their choices.",
        correctAnswer: "simulate",
        wordOptions: ["captivated", "premise", "simulate", "connect", "perspectives", "challenged", "idea", "understand", "escape", "surprised", "reasoning", "elucidate", "replace", "experiences", "facts"],
        partOfSpeech: "verb"
      },
      {
        blankIndex: 4,
        speaker: "Samantha",
        sentenceWithBlank: "I love that approach. Students often struggle to [BLANK 4] with abstract concepts when they can't see the real-world applications.",
        correctAnswer: "connect",
        wordOptions: ["captivated", "premise", "simulate", "connect", "perspectives", "challenged", "idea", "understand", "escape", "surprised", "reasoning", "elucidate", "replace", "experiences", "facts"],
        partOfSpeech: "verb"
      },
      {
        blankIndex: 5,
        speaker: "Roy",
        sentenceWithBlank: "Exactly. The most rewarding part has been seeing how they're applying these [BLANK 5] to current events. They're actually discussing historical parallels in their free time.",
        correctAnswer: "perspectives",
        wordOptions: ["captivated", "premise", "simulate", "connect", "perspectives", "challenged", "idea", "understand", "escape", "surprised", "reasoning", "elucidate", "replace", "experiences", "facts"],
        partOfSpeech: "noun"
      }
    ]
  },
  7: {
    levelId: 7,
    difficulty: 7,
    dialogueTitle: "Housing Development",
    blanks: [
      {
        blankIndex: 1,
        speaker: "Peter",
        sentenceWithBlank: "My latest article about the local housing development has caused quite a [BLANK 1]. I've received over fifty emails since it was published yesterday.",
        correctAnswer: "controversy",
        wordOptions: ["controversy", "polarizing", "represent", "whereas", "dilemma", "situation", "complex", "discern", "because", "response", "longstanding", "argue", "therefore", "truth", "evolution"],
        partOfSpeech: "noun"
      },
      {
        blankIndex: 2,
        speaker: "Pamela",
        sentenceWithBlank: "I'm not surprised. Housing is such a [BLANK 2] issue here. Did you manage to [BLANK 3] both perspectives fairly? That's always the challenge with these contentious topics.",
        correctAnswer: "polarizing",
        wordOptions: ["controversy", "polarizing", "represent", "whereas", "dilemma", "situation", "complex", "discern", "because", "response", "longstanding", "argue", "therefore", "truth", "evolution"],
        partOfSpeech: "adjective"
      },
      {
        blankIndex: 3,
        speaker: "Pamela", 
        sentenceWithBlank: "I'm not surprised. Housing is such a [BLANK 2] issue here. Did you manage to [BLANK 3] both perspectives fairly? That's always the challenge with these contentious topics.",
        correctAnswer: "represent",
        wordOptions: ["controversy", "polarizing", "represent", "whereas", "dilemma", "situation", "complex", "discern", "because", "response", "longstanding", "argue", "therefore", "truth", "evolution"],
        partOfSpeech: "verb"
      },
      {
        blankIndex: 4,
        speaker: "Peter",
        sentenceWithBlank: "I really tried to, but it's difficult when the developer refused to comment beyond their prepared statement, [BLANK 4] the community activists were extremely vocal.",
        correctAnswer: "whereas",
        wordOptions: ["controversy", "polarizing", "represent", "whereas", "dilemma", "situation", "complex", "discern", "because", "response", "longstanding", "argue", "therefore", "truth", "evolution"],
        partOfSpeech: "transition"
      },
      {
        blankIndex: 5,
        speaker: "Manuel",
        sentenceWithBlank: "That's the [BLANK 5] with these big development projects. By the time the public becomes aware, most of the decisions have already been made behind closed doors.",
        correctAnswer: "dilemma",
        wordOptions: ["controversy", "polarizing", "represent", "whereas", "dilemma", "situation", "complex", "discern", "because", "response", "longstanding", "argue", "therefore", "truth", "evolution"],
        partOfSpeech: "noun"
      }
    ],
    contextLines: [
      {
        speaker: "Peter",
        text: "Exactly. And then my job becomes about revealing those earlier processes rather than just reporting on current events.",
        position: "end"
      }
    ]
  },
  8: {
    levelId: 8,
    difficulty: 8,
    dialogueTitle: "Climate Report",
    blanks: [
      {
        blankIndex: 1,
        speaker: "Samantha",
        sentenceWithBlank: "The latest climate report makes it clear that we need to [BLANK 1] our conservation efforts if we want to see any meaningful change.",
        correctAnswer: "intensify",
        wordOptions: ["intensify", "accelerates", "compressed", "disconnect", "comprehensible", "clarify", "highlights", "inaccurate", "organized", "announce", "renders", "confusing", "overlap", "backlog", "vivid"],
        partOfSpeech: "verb"
      },
      {
        blankIndex: 2,
        speaker: "Peter",
        sentenceWithBlank: "I was just reading about that. The most troubling aspect is how the report [BLANK 2] previous predictions about coastal flooding.",
        correctAnswer: "accelerates",
        wordOptions: ["intensify", "accelerates", "compressed", "disconnect", "comprehensible", "clarify", "highlights", "inaccurate", "organized", "announce", "renders", "confusing", "overlap", "backlog", "vivid"],
        partOfSpeech: "verb"
      },
      {
        blankIndex: 3,
        speaker: "Roy",
        sentenceWithBlank: "It seems like each new study reveals more [BLANK 3] timelines than we anticipated.",
        correctAnswer: "compressed",
        wordOptions: ["intensify", "accelerates", "compressed", "disconnect", "comprehensible", "clarify", "highlights", "inaccurate", "organized", "announce", "renders", "confusing", "overlap", "backlog", "vivid"],
        partOfSpeech: "adjective"
      },
      {
        blankIndex: 4,
        speaker: "Samantha",
        sentenceWithBlank: "There's definitely a [BLANK 4] between scientific understanding and public perception. Most people still view climate change as a distant threat.",
        correctAnswer: "disconnect",
        wordOptions: ["intensify", "accelerates", "compressed", "disconnect", "comprehensible", "clarify", "highlights", "inaccurate", "organized", "announce", "renders", "confusing", "overlap", "backlog", "vivid"],
        partOfSpeech: "noun"
      },
      {
        blankIndex: 5,
        speaker: "Peter",
        sentenceWithBlank: "That's where good science communication becomes crucial. The challenge is making these complex systems [BLANK 5] without oversimplifying.",
        correctAnswer: "comprehensible",
        wordOptions: ["intensify", "accelerates", "compressed", "disconnect", "comprehensible", "clarify", "highlights", "inaccurate", "organized", "announce", "renders", "confusing", "overlap", "backlog", "vivid"],
        partOfSpeech: "adjective"
      }
    ]
  },
  9: {
    levelId: 9,
    difficulty: 9,
    dialogueTitle: "Urban Development",
    blanks: [
      {
        blankIndex: 1,
        speaker: "Pamela",
        sentenceWithBlank: "The city's new urban development plan completely [BLANK 1] the transit needs of the eastern neighborhoods. I'm considering making a formal complaint.",
        correctAnswer: "disregards",
        wordOptions: ["disregards", "inadequate", "pattern", "allocation", "Consequently", "mocks", "old", "conspiracy", "Of course", "inflames", "popular", "practicality", "distribution", "preferences", "objectives"],
        partOfSpeech: "verb"
      },
      {
        blankIndex: 2,
        speaker: "Manuel",
        sentenceWithBlank: "That's frustrating. Those areas already suffer from [BLANK 2] public transportation options compared to the western side of town.",
        correctAnswer: "inadequate",
        wordOptions: ["disregards", "inadequate", "pattern", "allocation", "Consequently", "mocks", "old", "conspiracy", "Of course", "inflames", "popular", "practicality", "distribution", "preferences", "objectives"],
        partOfSpeech: "adjective"
      },
      {
        blankIndex: 3,
        speaker: "Pamela",
        sentenceWithBlank: "Absolutely. And these decisions don't happen in a vacuum. There's a clear historical [BLANK 3] of neglecting neighborhoods with lower income demographics.",
        correctAnswer: "pattern",
        wordOptions: ["disregards", "inadequate", "pattern", "allocation", "Consequently", "mocks", "old", "conspiracy", "Of course", "inflames", "popular", "practicality", "distribution", "preferences", "objectives"],
        partOfSpeech: "noun"
      },
      {
        blankIndex: 4,
        speaker: "Roy",
        sentenceWithBlank: "It's the same pattern we see in educational resource [BLANK 4] as well. The systems might appear neutral on paper, but the outcomes consistently disadvantage the same communities.",
        correctAnswer: "allocation",
        wordOptions: ["disregards", "inadequate", "pattern", "allocation", "Consequently", "mocks", "old", "conspiracy", "Of course", "inflames", "popular", "practicality", "distribution", "preferences", "objectives"],
        partOfSpeech: "noun"
      },
      {
        blankIndex: 5,
        speaker: "Pamela",
        sentenceWithBlank: "[BLANK 5], we need to address these structural inequities before implementing any new development plans, or we'll just perpetuate the same problems.",
        correctAnswer: "Consequently",
        wordOptions: ["disregards", "inadequate", "pattern", "allocation", "Consequently", "mocks", "old", "conspiracy", "Of course", "inflames", "popular", "practicality", "distribution", "preferences", "objectives"],
        partOfSpeech: "transition"
      }
    ]
  },
  10: {
    levelId: 10,
    difficulty: 10,
    dialogueTitle: "Cultural Paradigms",
    blanks: [
      {
        blankIndex: 1,
        speaker: "Roy",
        sentenceWithBlank: "I've been reading this fascinating book about how cultural [BLANK 1] shape our understanding of historical events. It's changed how I approach teaching history entirely.",
        correctAnswer: "paradigms",
        wordOptions: ["paradigms", "marginalize", "influenced", "juxtaposed", "compel", "indicators", "outpace", "obscure", "hidden", "biases", "reinforce", "wronged", "interchange", "seduce", "allow"],
        partOfSpeech: "noun"
      },
      {
        blankIndex: 2,
        speaker: "Peter",
        sentenceWithBlank: "That sounds intriguing. Does it address how dominant narratives tend to [BLANK 2] alternative perspectives over time?",
        correctAnswer: "marginalize",
        wordOptions: ["paradigms", "marginalize", "influenced", "juxtaposed", "compel", "indicators", "outpace", "obscure", "hidden", "biases", "reinforce", "wronged", "interchange", "seduce", "allow"],
        partOfSpeech: "verb"
      },
      {
        blankIndex: 3,
        speaker: "Roy",
        sentenceWithBlank: "Absolutely. It argues that what we consider 'objective' history is actually deeply [BLANK 3] by whoever had the power to record and preserve those accounts.",
        correctAnswer: "influenced",
        wordOptions: ["paradigms", "marginalize", "influenced", "juxtaposed", "compel", "indicators", "outpace", "obscure", "hidden", "biases", "reinforce", "wronged", "interchange", "seduce", "allow"],
        partOfSpeech: "adjective"
      },
      {
        blankIndex: 4,
        speaker: "Joey",
        sentenceWithBlank: "That reminds me of that exhibit we saw last month where they [BLANK 4] historical artifacts with contemporary art to challenge traditional interpretations.",
        correctAnswer: "juxtaposed",
        wordOptions: ["paradigms", "marginalize", "influenced", "juxtaposed", "compel", "indicators", "outpace", "obscure", "hidden", "biases", "reinforce", "wronged", "interchange", "seduce", "allow"],
        partOfSpeech: "verb"
      },
      {
        blankIndex: 5,
        speaker: "Samantha",
        sentenceWithBlank: "What I find most compelling about these approaches is how they [BLANK 5] us to question our own inherent biases when consuming any form of information.",
        correctAnswer: "compel",
        wordOptions: ["paradigms", "marginalize", "influenced", "juxtaposed", "compel", "indicators", "outpace", "obscure", "hidden", "biases", "reinforce", "wronged", "interchange", "seduce", "allow"],
        partOfSpeech: "verb"
      }
    ]
  }
};

// Helper function to get instance by difficulty
export const getModule6Instance = (difficulty) => {
  const level = Math.min(Math.max(1, difficulty), 10); // Clamp between 1 and 10
  return MODULE_6_INSTANCES[level] || MODULE_6_INSTANCES[1];
};